import React from 'react';
import { reduxForm, Field, change, reset } from 'redux-form';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'

import { store } from '../../store';
import { setNuevaProvidencia, sendPost, setMunicipios } from '../../actions'

import axios from 'axios';

import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';

import PlaylistAdd from '@material-ui/icons/PlaylistAdd';
import { useRef, useEffect } from 'react';
import '../../AutoComplete.css';

//autoCompletar
import { getCodProceso } from '../../actions/getCodProceso';
import { getMagistrado } from '../../actions/getMagistrado';
import { getDemandante } from '../../actions/getDemandante';
import { getDemandado } from '../../actions/getDemandado';
import { getInstancia } from '../../actions/getInstancia';
import { getAccion } from '../../actions/getAccion';
import { getDescriptor } from '../../actions/getDescriptor';
import { getRestrictor } from '../../actions/getRestrictor';
import { getDecision } from '../../actions/getDecision';

import { getProcesosCod } from '../../actions/getProcesosCod';

const validate = values => {
    //console.log(values);
    const errors = {}
    const requiredFields = [
        'codProceso',
        'fecha',
        'magistrado',
        'demandante',
        'demandado',
        'instancia',
        'accion',
        'descriptor',
        'restrictor',
        'decisión',
    ]

    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = 'Requerido'
        }
    })

    /*  se deben separar por ; y luego validar uno a uno...
    if (values.terceroMail && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.terceroMail)) {
        errors.terceroMail = 'E-Mail no valido.'
    }

    if (values.terceroMailFO && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.terceroMailFO)) {
        errors.terceroMailFO = 'E-Mail no valido.'
    }

    if (values.terceroMailL && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.terceroMailL)) {
        errors.terceroMailL = 'E-Mail no valido.'
    }
    */


    return errors
}

const renderTextFieldb = (
    { input, label, meta: { touched, error }, ...custom },
) => (
        <TextField
            //hintText={label}
            //floatingLabelText={label}
            //errorText={touched && error}
            {...input}
            {...custom}
        />
    );

const renderTextField = ({
    label, name, type,
    input,
    meta: { touched, invalid, error },
    ...custom
}) => (
        <TextField
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
            variant="outlined"
            margin="normal"
            fullWidth
            autoComplete="off"
            type={type}
        />
    )

const renderSelectField = ({
    label, name, type,
    input,
    meta: { touched, invalid, error },
    ...custom
}) => (
        <Select
            label={label}
            placeholder={label}
            error={touched && invalid}
            helperText={touched && error}
            {...input}
            {...custom}
            variant="outlined"
            margin="normal"

            fullWidth
            type={type}
        //id={name}    

        />
    )


const mapStateToProps = state => ({
    initialValues: state.edicion.providencia,
    loggedIn: state.auth.loggedIn,
    auth: state.auth,
    apiFetch: state.apiFetch,
    //edicionTercero: state.edicion.tercero,

});

//const FrmCarga = ({ classes, handleSubmit, submitting, onBack, pristine, submitSucceeded }) => {
const FrmCarga = props => {
    const { handleSubmit, pristine, reset, submitting, classes } = props;
    const [openGrupo, setOpenGrupo] = React.useState(false);

    //initialValues: state.auth,
    const [estadoInicial, setEstadoInicial] = React.useState(true);

    //const terceroID = props.edicionTercero.terceroID === undefined ? '' : props.edicionTercero.terceroID;
    //const editando = terceroID === "" ? false : true;
    const editando = false;


    const [archivo, setArchivo] = React.useState("");
    const [enlace, setEnlace] = React.useState("");
    const [carga, setCarga] = React.useState(0);

    const fileUploadInput = React.useRef(null);

    const [showAutoCompletarCodProceso, setShowAutoCompletarCodProceso] = React.useState(false);
    const [showAutoCompletarMagistrado, setShowAutoCompletarMagistrado] = React.useState(false);
    const [showAutoCompletarDemandante, setShowAutoCompletarDemandante] = React.useState(false);
    const [showAutoCompletarDemandado, setShowAutoCompletarDemandado] = React.useState(false);
    const [showAutoCompletarInstancia, setShowAutoCompletarInstancia] = React.useState(false);
    const [showAutoCompletarAccion, setShowAutoCompletarAccion] = React.useState(false);
    const [showAutoCompletarDescriptor, setShowAutoCompletarDescriptor] = React.useState(false);
    const [showAutoCompletarRestrictor, setShowAutoCompletarRestrictor] = React.useState(false);
    const [showAutoCompletarDecision, setShowAutoCompletarDecision] = React.useState(false);

    const upper = value => value && value.toUpperCase();
    const lower = value => value && value.toLowerCase();
    const sinEspacios = value => value && value.replace(/\s\s+/g, ' ');

    function handleChange(event) {

        //console.log(event.target.name + " -->" + event.target.value);

        //event.target.value = event.target.value.replace(/\s\s+/g, ' ');
        //props.dispatch(change("FrmCarga", event.target.name, event.target.value));



        console.log(event.target.name + " -->" + event.target.value);

        if (event.target.name === "codProceso") {
            //let tmpLista = [];

            if (event.target.value.length > 3) {
                setShowAutoCompletarCodProceso(true);
                //tmpLista = ["a", "aa", "aaa", "aaaa", "aaaaa"];
                autoCompletarCodProcesoAPI(event.target.value)
            }
        }

        if (event.target.name === "magistrado") {

            if (event.target.value.length > 3) {
                setShowAutoCompletarMagistrado(true);
                autoCompletarMagistradoAPI(event.target.value)
            }
        }

        if (event.target.name === "demandante") {

            if (event.target.value.length > 3) {
                setShowAutoCompletarDemandante(true);
                autoCompletarDemandanteAPI(event.target.value)
            }
        }

        if (event.target.name === "demandado") {

            if (event.target.value.length > 3) {
                setShowAutoCompletarDemandado(true);
                autoCompletarDemandadoAPI(event.target.value)
            }
        }
        if (event.target.name === "instancia") {

            if (event.target.value.length > 3) {
                setShowAutoCompletarInstancia(true);
                autoCompletarInstanciaAPI(event.target.value)
            }
        }
        if (event.target.name === "accion") {
            //actualiza el valor de un campo del formulario.
            //props.change('accion', event.target.value);
            //console.log("***");
            //console.log(props);

            if (event.target.value.length > 3) {
                setShowAutoCompletarAccion(true);
                autoCompletarAccionAPI(event.target.value)
            }
        }
        if (event.target.name === "descriptor") {

            if (event.target.value.length > 3) {
                setShowAutoCompletarDescriptor(true);
                autoCompletarDescriptorAPI(event.target.value)
            }
        }
        if (event.target.name === "restrictor") {

            if (event.target.value.length > 3) {
                setShowAutoCompletarRestrictor(true);
                autoCompletarRestrictorAPI(event.target.value)
            }
        }
        if (event.target.name === "decision") {

            if (event.target.value.length > 3) {
                setShowAutoCompletarDecision(true);
                autoCompletarDecisionAPI(event.target.value)
            }
        }



    }

    const renderAutoCompletarCodProceso = () => {

        //verificacion   
        const lstData = props.apiFetch.getCodProceso === undefined ? [] : props.apiFetch.getCodProceso;

        if (lstData.length == 0 || showAutoCompletarCodProceso === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.codProceso} onClick={() => selectAutoCompletarCodProceso(i.codProceso)}>{i.codProceso}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarMagistrado = () => {

        //verificacion   
        const lstData = props.apiFetch.getMagistrado === undefined ? [] : props.apiFetch.getMagistrado;

        if (lstData.length == 0 || showAutoCompletarMagistrado === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.nombre} onClick={() => selectAutoCompletarMagistrado(i.nombre)}>{i.nombre}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarDemandante = () => {

        //verificacion   
        const lstData = props.apiFetch.getDemandante === undefined ? [] : props.apiFetch.getDemandante;

        if (lstData.length == 0 || showAutoCompletarDemandante === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.nombre} onClick={() => selectAutoCompletarDemandante(i.nombre)}>{i.nombre}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarDemandado = () => {

        //verificacion   
        const lstData = props.apiFetch.getDemandado === undefined ? [] : props.apiFetch.getDemandado;

        if (lstData.length == 0 || showAutoCompletarDemandado === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.nombre} onClick={() => selectAutoCompletarDemandado(i.nombre)}>{i.nombre}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarInstancia = () => {

        //verificacion   
        const lstData = props.apiFetch.getInstancia === undefined ? [] : props.apiFetch.getInstancia;

        if (lstData.length == 0 || showAutoCompletarInstancia === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.descripcionInstancia} onClick={() => selectAutoCompletarInstancia(i.descripcionInstancia)}>{i.descripcionInstancia}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarAccion = () => {

        //verificacion   
        const lstData = props.apiFetch.getAccion === undefined ? [] : props.apiFetch.getAccion;

        if (lstData.length == 0 || showAutoCompletarAccion === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.descripcionAccion} onClick={() => selectAutoCompletarAccion(i.descripcionAccion)}>{i.descripcionAccion}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarDescriptor = () => {

        //verificacion   
        const lstData = props.apiFetch.getDescriptor === undefined ? [] : props.apiFetch.getDescriptor;

        if (lstData.length == 0 || showAutoCompletarDescriptor === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.descripcionDescriptor} onClick={() => selectAutoCompletarDescriptor(i.descripcionDescriptor)}>{i.descripcionDescriptor}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarRestrictor = () => {

        //verificacion   
        const lstData = props.apiFetch.getRestrictor === undefined ? [] : props.apiFetch.getRestrictor;

        if (lstData.length == 0 || showAutoCompletarRestrictor === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.descripcionRestrictor} onClick={() => selectAutoCompletarRestrictor(i.descripcionRestrictor)}>{i.descripcionRestrictor}</li>)}
            </ul>
        )
    }

    const renderAutoCompletarDecision = () => {

        //verificacion   
        const lstData = props.apiFetch.getDecision === undefined ? [] : props.apiFetch.getDecision;

        if (lstData.length == 0 || showAutoCompletarDecision === false) {
            return null;
        }

        return (
            <ul>
                {lstData.map((i) => <li key={i.descripcionDecision} onClick={() => selectAutoCompletarDecision(i.descripcionDecision)}>{i.descripcionDecision}</li>)}
            </ul>
        )
    }


    const selectAutoCompletarCodProceso = (cual) => {
        props.dispatch(change("FrmCarga", "codProceso", cual));
        setEnlace("");

        props.getProcesosCod("/" + encodeURIComponent(cual));
        setShowAutoCompletarCodProceso(false);

    }

    const selectAutoCompletarMagistrado = (cual) => {
        props.dispatch(change("FrmCarga", "magistrado", cual));
        setShowAutoCompletarMagistrado(false);
    }
    const selectAutoCompletarDemandante = (cual) => {
        props.dispatch(change("FrmCarga", "demandante", cual));
        setShowAutoCompletarDemandante(false);
    }
    const selectAutoCompletarDemandado = (cual) => {
        props.dispatch(change("FrmCarga", "demandado", cual));
        setShowAutoCompletarDemandado(false);
    }
    const selectAutoCompletarInstancia = (cual) => {
        props.dispatch(change("FrmCarga", "instancia", cual));
        setShowAutoCompletarInstancia(false);
    }
    const selectAutoCompletarAccion = (cual) => {
        props.dispatch(change("FrmCarga", "accion", cual));
        setShowAutoCompletarAccion(false);
    }
    const selectAutoCompletarDescriptor = (cual) => {
        props.dispatch(change("FrmCarga", "descriptor", cual));
        setShowAutoCompletarDescriptor(false);
    }
    const selectAutoCompletarRestrictor = (cual) => {
        props.dispatch(change("FrmCarga", "restrictor", cual));
        setShowAutoCompletarRestrictor(false);
    }
    const selectAutoCompletarDecision = (cual) => {
        props.dispatch(change("FrmCarga", "decision", cual));
        setShowAutoCompletarDecision(false);
    }


    function autoCompletarCodProcesoAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getCodProceso(urlParams);


    }

    function autoCompletarMagistradoAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getMagistrado(urlParams);
    }

    function autoCompletarDemandanteAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getDemandante(urlParams);
    }

    function autoCompletarDemandadoAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getDemandado(urlParams);
    }

    function autoCompletarInstanciaAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getInstancia(urlParams);
    }

    function autoCompletarAccionAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getAccion(urlParams);
    }

    function autoCompletarDescriptorAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getDescriptor(urlParams);
    }

    function autoCompletarRestrictorAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getRestrictor(urlParams);
    }

    function autoCompletarDecisionAPI(cual) {

        if (cual === undefined) {

            return;
        }

        var urlParams = "";
        urlParams += "/" + encodeURIComponent(cual);

        props.getDecision(urlParams);
    }


    function formReset() {
        props.dispatch(change("FrmCarga", "archivo", ""));
        setCarga(0);
        setEnlace("");
        store.dispatch(setNuevaProvidencia())
        props.dispatch(reset('myForm'));

        console.log("Reset form...");
        //debugger;
    }

    const fileSelectedHandler = (e) => {
        console.log(e.target.files[0]);
        setArchivo(e.target.files[0]);
    }

    const fileUploadHandler = (e) => {
        props.dispatch(change("FrmCarga", "archivo", ""));
        console.log(archivo);
        setCarga(1);

        const fd = new FormData();
        fd.append('archivo', archivo, archivo.name);
        axios.post('http://ramajudicialdelhuila.gov.co/PortalREST/index.php/RamaUpload/postDocs', fd)
            .then(res => {

                if (res.data.cod === "1") {
                    setCarga(2);
                    setEnlace(encodeURIComponent(res.data.msg));
                    console.log(encodeURIComponent(res.data.msg));
                    props.dispatch(change("FrmCarga", "archivo", res.data.msg));
                    props.dispatch(change("FrmCarga", "expediente", res.data.expediente));
                    props.dispatch(change("FrmCarga", "folder", res.data.folder));
                    props.dispatch(change("FrmCarga", "extArchivo", res.data.extArchivo));
                    //debugger;
                }
                else {
                    setCarga(0);
                    setEnlace("");
                }

                console.log(res);

            });
    }
    console.log("umm enviando?..." + submitting);

    return (
        <div className="cargaDocumentos">
            <Grid container spacing={2}>
                <Grid item xs={12} sm={5}>
                    <form className={classes.form} onSubmit={handleSubmit} >

                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={7} className="AutoComplete" >
                                <Field name="codProceso" onChange={handleChange} component={renderTextField} label="Código De Proceso" type="text" normalize={sinEspacios} autoFocus />
                                {renderAutoCompletarCodProceso()}
                            </Grid>
                            <Grid item xs={12} sm={5} >
                                <Field name="fecha" component={renderTextField} label="Fecha nombre" type="date" />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className="AutoComplete">
                            <Field name="magistrado" onChange={handleChange} component={renderTextField} label="Magistrado" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarMagistrado()}
                        </Grid>

                        <Grid item xs={12} className="AutoComplete">
                            <Field name="demandante" onChange={handleChange} component={renderTextField} label="Demandante" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarDemandante()}
                        </Grid>

                        <Grid item xs={12} className="AutoComplete">
                            <Field name="demandado" onChange={handleChange} component={renderTextField} label="Demandado" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarDemandado()}
                        </Grid>

                        <Grid item xs={12} className="AutoComplete">
                            <Field name="instancia" onChange={handleChange} component={renderTextField} label="Instancia" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarInstancia()}
                        </Grid>

                        <Grid item xs={12} className="AutoComplete">
                            <Field name="accion" onChange={handleChange} component={renderTextField} label="Medio de control" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarAccion()}
                        </Grid>
                        <Grid item xs={12} className="AutoComplete">
                            <Field name="descriptor" onChange={handleChange} component={renderTextField} label="Descriptor" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarDescriptor()}
                        </Grid>
                        <Grid item xs={12} className="AutoComplete">
                            <Field name="restrictor" onChange={handleChange} component={renderTextField} label="Restrictor" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarRestrictor()}
                        </Grid>
                        <Grid item xs={12} className="AutoComplete">
                            <Field name="decision" onChange={handleChange} component={renderTextField} label="Decisión" type="text" normalize={sinEspacios} />
                            {renderAutoCompletarDecision()}
                        </Grid>


                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={1} >
                            </Grid>

                            <Grid item xs={12} sm={5} >
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={formReset}
                                    className={classes.submit}>Limpiar</Button>
                            </Grid>
                            <Grid item xs={12} sm={5} >
                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    disabled={submitting}
                                    className={classes.submit}>Enviar</Button>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>


                <Grid item xs={12} sm={7}>

                    <Grid item xs={12} sm={12} >
                        {enlace !== "" ? <iframe src={`https://view.officeapps.live.com/op/embed.aspx?src=${enlace}&amp;wdStartOn=1`}
                            width="100%"
                            height="600px"
                            frameBorder="0">Esto es un documento de <a target="_blank" href="https://office.com">Microsoft Office</a> incrustado con tecnología de <a target="_blank" href="https://office.com/webapps">Office</a>.
                        </iframe> : ''}
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6} >
                            <input style={{ display: 'none' }} type="file" onChange={fileSelectedHandler} ref={fileUploadInput} />
                            <Button
                                onClick={() => fileUploadInput.current.click()}
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>Seleccionar Archivo</Button>
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <Button
                                onClick={fileUploadHandler}
                                fullWidth
                                variant="contained"
                                color="primary"
                                className={classes.submit}>Cargar</Button>
                            {carga === 1 ? <CircularProgress className={classes.progress} /> : ''}
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </div>
    );
};

FrmCarga.propTypes = {
    email: PropTypes.string,
    password: PropTypes.string,
    //age: PropTypes.number,
    //onBack: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ change }, dispatch);
}


export default connect(mapStateToProps, { getCodProceso, getProcesosCod, getMagistrado, getDemandante, getDemandado, getInstancia, getAccion, getDescriptor, getRestrictor, getDecision })(reduxForm({
    form: 'FrmCarga', validate, enableReinitialize: true
})(FrmCarga));

const cargarDatos = (props) => {

    const info = props.getContadorDetalle();
    return info;
};

function hasNumber(value) {
    return value.match(/\d+/g) != null;
}

function hasUpper(value) {

    if (!(value === undefined)) {

        return value.match(/[A-Z]+/g) == null;
    }
    else {

        return true;
    }
}

function hasLower(value) {
    return value.match(/[a-z]+/g) != null;
}

function hasSpecial(value) {
    // eslint-disable-next-line
    const exp = new RegExp(/[\~\`\!\@\#\$\%\^\&\*\(\)\-\=\[\]\'\;\\\/\.\,\<\>\?\:\"\{\}\+\_\"]+/g);
    return value.match(exp) != null;
}
